/**
 * ClientFilter Component
 *
 * Dropdown to filter data by client.
 */
import type { Client } from '../../types';

interface ClientFilterProps {
  clients: Client[];
  selectedClientId: string | null;
  onChange: (clientId: string | null) => void;
  showAllOption?: boolean;
  allLabel?: string;
  loading?: boolean;
}

export const ClientFilter = ({
  clients,
  selectedClientId,
  onChange,
  showAllOption = true,
  allLabel = 'All Clients',
  loading = false,
}: ClientFilterProps) => {
  return (
    <div className="flex items-center gap-2">
      <label className="text-sm font-medium text-gray-700">
        Filter by Client:
      </label>
      <select
        value={selectedClientId || ''}
        onChange={(e) => onChange(e.target.value || null)}
        disabled={loading}
        className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-metrica-green focus:border-metrica-green disabled:bg-gray-100"
      >
        {showAllOption && (
          <option value="">{allLabel}</option>
        )}
        {clients.map((client) => (
          <option key={client.id} value={client.id}>
            {client.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ClientFilter;
